import React, {Component} from 'react';
import Select from"../../../local_node_modules/react-select"
import '../../../local_node_modules/react-select/dist/react-select.css';
import 'moment/locale/tr';
import ExternalCustomerModal from "../../voucher/component/ExternalCustomerModal";
import {getForeignCompanyInfo} from "../../../helper/helper";
import {ExternalCustomerMainType} from "../../../helper/enums";

class ForeignCompanyInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {modal: false};
		this.editForeignCompanyInfo = this.editForeignCompanyInfo.bind(this);
		this.onChangeForeignCompany = this.onChangeForeignCompany.bind(this);
		this.setForeignCompanyInfo = this.setForeignCompanyInfo.bind(this);
		this.clearExternalCustomer = this.clearExternalCustomer.bind(this);
	}

	componentWillMount() {
		let externalCustomer = this.props.externalCustomer;
		externalCustomer.isForeignCustomer = true;
		let externalCustomerAddress = this.props.externalCustomerAddress;
		this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress});
	}

	setForeignCompanyInfo(externalCustomer, externalCustomerAddress, sendParent, modal) {
		this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress, modal: modal});
		if (sendParent)
			this.props.listener(externalCustomer, externalCustomerAddress);
	}

	onChangeForeignCompany(item) {
		let externalCustomer = JSON.parse(item.value);
		let externalCustomerAddress = {};
		if (externalCustomer.externalCustomerAddressList.length > 0) {
			externalCustomerAddress = externalCustomer.externalCustomerAddressList[0];
		} else {
			externalCustomerAddress = {
				buildingName: null,
				buildingNo: null,
				cityName: null,
				citySubdivisionName: null,
				countryName: "Türkiye",
				email: null,
				fax: null,
				postalAddressRegion: null,
				postalAddressRoom: null,
				postalZone: null,
				postboxAlias: "",
				recordId: null,
				streetName: null,
				telephone: null,
				webSite: null,
			};
		}
		this.setState({externalCustomer: externalCustomer, externalCustomerAddress: externalCustomerAddress});
		this.props.listener(externalCustomer, externalCustomerAddress);
	}

	editForeignCompanyInfo() {
		let externalCustomer = this.state.externalCustomer;
		let externalCustomerAddress = this.state.externalCustomerAddress;
		this.setState({
			externalCustomer: externalCustomer,
			externalCustomerAddress: externalCustomerAddress,
			modal: true
		});
	}

	clearExternalCustomer() {
		let externalCustomer = {
			commerceChamber: null,
			customer: null,
			externalCustomerAddressList: [],
			familyName: null,
			formattedName: null,
			givenName: null,
			mersisNumber: null,
			middleName: null,
			recordId: null,
			taxOffice: null,
			title: null,
			tradeRegistrationNumber: null,
			vknTckn: null
		};

		let externalCustomerAddress = {
			buildingName: null,
			buildingNo: null,
			cityName: null,
			citySubdivisionName: null,
			countryName: null,
			email: null,
			fax: null,
			postalAddressRegion: null,
			postalAddressRoom: null,
			postalZone: null,
			postboxAlias: null,
			recordId: null,
			streetName: null,
			telephone: null,
			webSite: null
		};

		this.setState({
			externalCustomer: externalCustomer,
			externalCustomerAddress: externalCustomerAddress,
			modal: false
		});
		this.props.listener(externalCustomer, externalCustomerAddress);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.error !== nextProps.error) {
			this.setState({error: nextProps.error});
		}
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	render() {
		return (
			<div className="row">
				<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 row" style={{marginBottom: '20px'}}>
					<div className="col-sm-9">
						<div className="form-group">
							<Select.Async multi={false}
										  ignoreAccents={false}
										  disabled={this.props.invoiceTypeCode === "SGK"}
										  value={this.props.externalCustomer.recordId ? {
											  value: JSON.stringify(this.props.externalCustomer),
											  label: this.props.externalCustomer.recordId ?((this.props.externalCustomer.title || this.props.externalCustomer.formattedName || (this.props.externalCustomer.givenName + " " + this.props.externalCustomer.familyName)) +(this.props.externalCustomer.vknTckn ? "("+this.props.externalCustomer.vknTckn+")":"")):null

										  } : null}
										  onChange={(e) => e && this.onChangeForeignCompany(e)}
										  isLoading={true}
										  autoload={false}
										  cache={false}
										  clearable={false}
										  arrowRenderer={this.arrowRenderer}
										  filterOptions={(options, filter, currentValues)=> options}
										  noResultsText="Kayıt bulunamadı."
										  searchPromptText="Arama için en az 1 karakter giriniz."
										  placeholder="Yabancı Firma Unvanı ile arama yapabilirsiniz"
										  loadingPlaceholder="Yükleniyor..."
										  loadOptions={(key) => getForeignCompanyInfo(key,this.props.includeForeign)}/>
						</div>
					</div>
					<div className="col-sm-3">
						<div className="form-group">
							<button type="button"
									className="TekBtn delete"
									onClick={this.clearExternalCustomer}
									style={{background: '#FFCCCC'}}
							>Temizle
							</button>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Yabancı VKN</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={this.props.externalCustomer.vknTckn || ""}/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Firma Unvanı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={this.props.externalCustomer.formattedName || ""}/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Alıcı Türü</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={(this.props.externalCustomer.buyerType === "TUZEL" ? "Tüzel" : this.props.externalCustomer.buyerType === "OZEL" ? "Özel" : "") || ""}/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Adres</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={((this.props.externalCustomerAddress.postalAddressRegion || "") + " " +
									   (this.props.externalCustomerAddress.streetName || "") + " " +
									   (this.props.externalCustomerAddress.buildingName || "") + " " +
									   (this.props.externalCustomerAddress.buildingNo || "") + " " +
									   (this.props.externalCustomerAddress.postalAddressRoom || "") + " " +
									   (this.props.externalCustomerAddress.postalZone || "") + " " +
									   (this.props.externalCustomerAddress.citySubdivisionName || "") + " " +
									   (this.props.externalCustomerAddress.cityName || "") + " " +
									   (this.props.externalCustomerAddress.countryName || "")).trim()
								   }/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Adı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={this.props.externalCustomer.givenName || ""}/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Soyadı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={this.props.externalCustomer.familyName || ""}/>
						</div>
					</div>
				</div>

				<div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 row" style={{marginRight: '0', padding: '0 0 0 15px'}}>
					<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
						<label>Firma Adı</label>
					</div>
					<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12">
						<div className="form-group">
							<input className="form-control"
								   disabled
								   type="text"
								   value={this.props.externalCustomer.title || ""}/>
						</div>
					</div>
				</div>

				{this.props.invoiceTypeCode !== "SGK" &&
				<div className="col-sm-12">
					<div className="form-group">
						<button type="button"
								className={"TekBtn pull-right " + (this.state.externalCustomer.recordId ? "edit" : "ekle")}
								style={{
									marginBottom: '5px',
									marginTop: '10px',
									marginRight: '28px',
									padding: '9px 54px 9px 23px',
									background: (this.state.externalCustomer.vknTckn ? 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))' : '')
								}}
								onClick={this.editForeignCompanyInfo}>{"Yabancı Firma " + (this.state.externalCustomer.recordId ? "Düzenle" : "Oluştur")}
						</button>
					</div>
				</div>
				}
				{this.state.modal &&
				<ExternalCustomerModal type={null}
									   showBuyerType={true}
									   title="Yabancı Firma Bilgileri"
									   listener={this.setForeignCompanyInfo}
									   modal={this.state.modal}
									   cities={this.props.cities}
									   countries={this.props.countries}
									   externalCustomer={this.state.externalCustomer}
									   externalCustomerAddress={this.state.externalCustomerAddress}
									   externalCustomerMainType = {ExternalCustomerMainType.Foreign}/>
				}
			</div>
		);
	}
}

export default ForeignCompanyInfo;